import { Box, Typography, Stack, Link } from "@mui/material";
import PointsSkeleton from "../PointsSkeleton";

const FooterServices = ({ services, title, handleScroll, theme }) => {
    return (
        <Box>
            <Box sx={{ display: "flex", alignItems: "center", mb: 3, gap: 1.5 }}>
                <Box sx={{ width: 24, height: 2, bgcolor: theme.palette.primary.main }} />
                <Typography
                    variant="subtitle1"
                    fontWeight={600}
                    sx={{ 
                        color: theme.palette.common.white,
                        fontFamily: theme.typography.h3.fontFamily
                    }}
                >
                    {title}
                </Typography>
            </Box>

            <Stack spacing={2}>
                {services.length === 0 ? (
                    <PointsSkeleton count={4} />
                ) : (
                    services.map((service) => (
                        <Link
                            key={service._id}
                            onClick={() => handleScroll("services")}
                            underline="none"
                            sx={{
                                cursor: "pointer",
                                color: theme.palette.custom.footerText,
                                transition: "0.3s",
                                "&:hover": {
                                    color: theme.palette.custom.footerLinkHover,
                                },
                                typography: 'textSm'
                            }}
                        >
                            {service.title}
                        </Link>
                    ))
                )}
            </Stack>
        </Box>
    );
}

export default FooterServices